<div class="flex flex-col gap-4">
  <div class="flex justify-between items-center gap-3">
    <div class="flex-1 flex flex-col gap-1">
      <div class="text-sm">{{'ERX.patient' | translate}}</div>
      <div class="text-sm font-semibold">{{prescription.user?.firstName}} {{prescription.user?.lastName}}</div>
    </div>

    <div class="flex-1 flex flex-col gap-1">
      <div class="text-sm">{{'SHARED.DATE_OF_BIRTH' | translate}}</div>
      <div class="text-sm font-semibold">{{prescription.user?.dateOfBirth}}</div>
    </div>

    <div class="flex-1 flex flex-col gap-1">
      <div class="text-sm">{{'ERX.doctor' | translate}}</div>
      <div class="text-sm font-semibold">{{prescription.employee?.firstName}} {{prescription.employee?.lastName}}</div>
    </div>
  </div>

  <div class="flex justify-between items-center gap-3">
    <div class="flex-1 flex flex-col gap-1">
      <div class="text-sm">{{'SHARED.PERSONAL_NUMBER' | translate}}</div>
      <div class="text-sm font-semibold">{{prescription.user?.idNumber}}</div>
    </div>

    <div class="flex-1 flex flex-col gap-1">
      <div class="text-sm">{{'ERX.prodCount' | translate}}</div>
      <div class="text-sm font-semibold">{{prescription.prodCount}}</div>
    </div>

    <div class="flex-1 flex flex-col gap-1">
      <div class="text-sm">{{'ERX.periodInput' | translate}}</div>
      <div class="text-sm font-semibold">{{prescription.duration}}</div>
    </div>
  </div>

  <hr/>
  <div class="flex justify-between items-center gap-3">
    <div class="flex-1 flex flex-col gap-1">
      <div class="text-sm">{{'ERX.ds' | translate}}</div>
      <div class="text-sm font-semibold">{{prescription.ds}}</div>
    </div>

  </div>

  <hr/>

  <table style="margin-top: 20px">
    <tr>
      <td style="width: 33%">{{'ERX.productId' | translate}}</td>
      <th class="item-alignment item-padding">{{prescription.product?.productId}}</th>
    </tr>
    <tr>
      <td>{{'ERX.tradeName' | translate}}</td>
      <th class="item-alignment item-padding">{{prescription.product?.geoTradeName}}</th>
    </tr>
    <tr>
      <td>{{'ERX.generic' | translate}}</td>
      <th class="item-alignment item-padding">{{prescription.product?.productGeneric}}</th>
    </tr>
    <tr>
      <td>{{'ERX.product.IssuanceMode' | translate}}</td>
      <th class="item-alignment item-padding">{{prescription.product?.issuanceMode}}</th>
    </tr>
    <tr>
      <td>{{'ERX.product.Api' | translate}}</td>
      <th class="item-alignment item-padding">{{prescription.product?.api}}</th>
    </tr>
    <tr>
      <td>{{'ERX.product.ManufacturerCountryName' | translate}}</td>
      <th class="item-alignment item-padding">{{prescription.product?.manufacturerCountryName}}</th>
    </tr>
     <tr>
      <td>{{'ERX.product.Manufacturer' | translate}}</td>
       <th class="item-alignment item-padding">{{prescription.product?.manufacturer}}</th>
    </tr>
     <tr>
      <td>{{'ERX.product.OtherDetailsGeo' | translate}}</td>
       <th class="item-alignment item-padding">{{prescription.product?.otherDetailsGeo}}</th>
    </tr>
     <tr>
      <td>{{'ERX.product.PharmaTherapyGroup' | translate}}</td>
       <th class="item-alignment item-padding">{{prescription.product?.pharmaTherapyGroup}}</th>
    </tr>
  </table>
</div>

<div *nzModalFooter>
  <button nz-button nzType="default" (click)="modalRef.close()">{{ 'general.cancel' | translate }}</button>
  <button nz-button nzType="primary" (click)="submit()">{{ 'ERX.send' | translate }}</button>
  <button nz-button nzType="primary" (click)="download(prescription)">{{ 'ERX.print' | translate }}</button>
</div>
